import { render, staticRenderFns } from "./SuspendAdvertisementButton.vue?vue&type=template&id=730df79b&"
import script from "./SuspendAdvertisementButton.vue?vue&type=script&lang=ts&"
export * from "./SuspendAdvertisementButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports